import { css } from "lit";

export const checkboxStyles = css`
  .fake-checkbox,
  .fake-switch {
    display: block;
    position: relative;

    input {
      position: absolute;
      opacity: 0;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      cursor: pointer;
      margin: 0;
      z-index: 1;
    }
  }

  .fake-checkbox {
    display: block;
    position: relative;
    width: 16px;
    height: 16px;
    border-radius: var(--sds-size-radius-100);
    border: var(--sds-size-stroke-border) solid var(--sds-color-border-brand-tertiary);
    background: var(--sds-color-background-default-default);
    appearance: none;

    &:has(input:checked) {
      background: var(--sds-color-background-brand-default);

      &::before {
        content: "\\2713";
        font-family: var(--sds-typography-family-body), sans-serif;
        color: var(--sds-color-background-default-default);
        width: 75%;
        height: 75%;
        line-height: 100%;
        text-align: center;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }

  .fake-switch {
    text-indent: -9999px;
    width: var(--sds-size-space-1200);
    height: var(--sds-size-space-600);
    display: block;
    border-radius: 9999px;
    border: 1px solid var(--sds-color-border-default-default);
    background: var(--sds-color-background-default-secondary);
    position: relative;
    transition: 0.3s;

    &::before {
      content: "";
      position: absolute;
      top: 18.75%;
      left: 9.375%;
      width: 31.25%;
      height: 62.5%;
      background: var(--sds-color-background-neutral-default);
      border-radius: 9999px;
      transition: 0.3s;
    }

    &:has(input:checked) {
      background: var(--sds-color-background-positive-default);

      &::before {
        background: var(--sds-color-background-default-default);
        left: calc(100% - 9.375%);
        transform: translateX(-100%);
      }
    }

    &:active::before {
      width: 62.5%;
    }
  }
`;
